import axios from "axios";

const axiosInstance = axios.create({
    baseURL: "https://expense-tracker-server-saurav.herokuapp.com/",
});

export default axiosInstance;
